import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';

@Component({
  selector: 'app-education-resources',
  templateUrl: './education-resources.component.html',
  styleUrls: ['./education-resources.component.css']
})
export class EducationResourcesComponent implements OnInit {

  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('education-resources').subscribe(result => {
      this.faq = result;
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    }, error => {
      console.error(error);
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    });
  }

}
